module.exports = __webpack_public_path__ + "img/404s.c5ea3d5f.png";